import script from "./Countdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./Countdown.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__